/* THALLÓ theme — vanilla JS, no dependencies */
(function () {
  'use strict';

  var T = window.thTheme || {};
  var R = T.routes || {};
  var S = T.strings || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = T.moneyFormat || '{{amount_with_comma_separator}}€';
    var v = cents / 100;
    function comma(n, dec) {
      var p = n.toFixed(dec).split('.');
      return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (p[1] ? ',' + p[1] : '');
    }
    function dot(n, dec) {
      var p = n.toFixed(dec).split('.');
      return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (p[1] ? '.' + p[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, key) {
      if (key === 'amount') return dot(v, 2);
      if (key === 'amount_no_decimals') return dot(v, 0);
      if (key === 'amount_with_comma_separator') return comma(v, 2);
      if (key === 'amount_no_decimals_with_comma_separator') return comma(v, 0);
      if (key === 'amount_with_space_separator') return v.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return comma(v, 2);
    });
  }

  /* ---------- toast ---------- */
  var toastEl = null, toastTimer = null;
  function toast(msg) {
    toastEl = toastEl || $('#th-toast');
    if (!toastEl) return;
    var span = $('.th-toast__msg', toastEl);
    if (span) span.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  }

  /* ---------- panels ---------- */
  function scrim(on) {
    var el = $('#th-scrim');
    if (el) el.classList.toggle('is-on', !!on);
    document.body.style.overflow = on ? 'hidden' : '';
  }
  function closeAll() {
    $$('.th-drawer.is-open,.th-mnav.is-open').forEach(function (p) { p.classList.remove('is-open'); });
    scrim(false);
  }

  /* ---------- header ---------- */
  function initHeader() {
    var hdr = $('#th-hdr');
    if (hdr) {
      var onScroll = function () { hdr.classList.toggle('is-stuck', window.scrollY > 12); };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }
    var burger = $('#th-burger'), mnav = $('#th-mnav');
    if (burger && mnav) burger.addEventListener('click', function () { mnav.classList.add('is-open'); scrim(true); });
    $$('[data-th-close]').forEach(function (b) { b.addEventListener('click', closeAll); });
    var sc = $('#th-scrim');
    if (sc) sc.addEventListener('click', closeAll);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  }

  /* ---------- announcement rotator ---------- */
  function initAnn() {
    var items = $$('.th-ann__item');
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-on');
      i = (i + 1) % items.length;
      items[i].classList.add('is-on');
    }, 4400);
  }

  /* ---------- SIGNATURE: skin type ---------- */
  var KEY = 'th_skin';
  function getSkin() {
    try { return localStorage.getItem(KEY) || ''; } catch (e) { return ''; }
  }
  function setSkin(v) {
    try { if (v) { localStorage.setItem(KEY, v); } else { localStorage.removeItem(KEY); } } catch (e) {}
  }
  function paintSkin() {
    var v = getSkin();
    $$('[data-th-skin-name]').forEach(function (el) {
      el.textContent = v ? v.toLowerCase() : (el.getAttribute('data-fallback') || '');
    });
    $$('[data-th-if-skin]').forEach(function (el) { el.hidden = !v; });
    $$('[data-th-if-noskin]').forEach(function (el) { el.hidden = !!v; });
    var box = $('#th-skin');
    if (box) {
      box.classList.toggle('is-set', !!v);
      var b = $('.th-skin__done b', box);
      if (b) b.textContent = v.toLowerCase();
      $$('.th-skin__o', box).forEach(function (o) {
        o.classList.toggle('is-on', o.getAttribute('data-val') === v);
      });
    }
  }
  function initSkin() {
    paintSkin();
    var box = $('#th-skin');
    if (!box) return;
    $$('.th-skin__o', box).forEach(function (o) {
      o.addEventListener('click', function () {
        var v = o.getAttribute('data-val');
        setSkin(v);
        paintSkin();
        toast(S.saved || 'Το κρατήσαμε.');
      });
    });
    var reset = $('.th-skin__reset', box);
    if (reset) reset.addEventListener('click', function (e) {
      e.preventDefault();
      setSkin('');
      paintSkin();
    });
  }

  /* ---------- reveal ---------- */
  function initReveal() {
    var els = $$('.th-rv');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- counters ---------- */
  function initCounters() {
    var els = $$('[data-th-count]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.textContent = e.getAttribute('data-th-count'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var el = en.target;
        var raw = (el.getAttribute('data-th-count') || '0').replace(',', '.');
        var dec = raw.indexOf('.') > -1 ? 1 : 0;
        var target = parseFloat(raw) || 0;
        var t0 = null, dur = 1600;
        function step(ts) {
          if (!t0) t0 = ts;
          var p = Math.min((ts - t0) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          var val = (target * eased).toFixed(dec);
          el.textContent = dec ? val.replace('.', ',') : Math.round(target * eased).toString();
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- accordions ---------- */
  function initAcc() {
    $$('[data-th-acc]').forEach(function (item) {
      var btn = $('[data-th-acc-q]', item);
      var panel = $('[data-th-acc-a]', item);
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var open = item.classList.contains('is-open');
        var group = item.getAttribute('data-th-acc');
        if (group === 'single' && !open) {
          $$('[data-th-acc="single"].is-open').forEach(function (o) {
            o.classList.remove('is-open');
            var p = $('[data-th-acc-a]', o); if (p) p.style.maxHeight = '';
            var b = $('[data-th-acc-q]', o); if (b) b.setAttribute('aria-expanded', 'false');
          });
        }
        item.classList.toggle('is-open', !open);
        btn.setAttribute('aria-expanded', String(!open));
        panel.style.maxHeight = open ? '' : panel.scrollHeight + 'px';
      });
    });
  }

  /* ---------- gallery ---------- */
  function initGallery() {
    var main = $('#th-pdp-main');
    if (!main) return;
    $$('[data-th-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-src');
        if (src) main.src = src;
        $$('[data-th-thumb]').forEach(function (x) { x.classList.remove('is-on'); });
        t.classList.add('is-on');
      });
    });
  }

  /* ---------- variants ---------- */
  function initVariants() {
    var root = $('#th-pdp');
    if (!root) return;
    var dataEl = $('#th-variants');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var form = $('#th-product-form');
    var idInput = $('#th-variant-id');
    var priceBox = $('#th-pdp-price');
    var btn = $('#th-atc');
    var chosen = [];

    $$('[data-th-opt]', root).forEach(function (b) {
      var idx = parseInt(b.getAttribute('data-th-opt'), 10);
      if (b.classList.contains('is-on')) chosen[idx] = b.getAttribute('data-val');
      b.addEventListener('click', function () {
        $$('[data-th-opt="' + idx + '"]', root).forEach(function (x) { x.classList.remove('is-on'); });
        b.classList.add('is-on');
        chosen[idx] = b.getAttribute('data-val');
        update();
      });
    });

    function label(txt) {
      if (!btn) return;
      var sp = btn.querySelector('span');
      if (sp) sp.textContent = txt;
    }

    function update() {
      var found = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var k = 0; k < chosen.length; k++) {
          if (chosen[k] && v.options[k] !== chosen[k]) { ok = false; break; }
        }
        if (ok) { found = v; break; }
      }
      if (!found) {
        if (btn) { btn.setAttribute('aria-disabled', 'true'); label(S.unavailable || 'Μη διαθέσιμο'); }
        return;
      }
      if (idInput) idInput.value = found.id;
      if (priceBox) {
        var html = '<span class="th-price' + (found.compare_at_price > found.price ? ' th-price--sale' : '') + '">' + money(found.price) + '</span>';
        if (found.compare_at_price && found.compare_at_price > found.price) {
          html += '<span class="th-price th-price--was">' + money(found.compare_at_price) + '</span>';
        }
        priceBox.innerHTML = html;
      }
      if (btn) {
        if (found.available) {
          btn.removeAttribute('aria-disabled');
          label(S.add_to_cart || 'Προσθήκη στο καλάθι');
        } else {
          btn.setAttribute('aria-disabled', 'true');
          label(S.sold_out || 'Εξαντλήθηκε');
        }
      }
      if (window.history && window.history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', found.id);
          window.history.replaceState({}, '', u.toString());
        } catch (e) {}
      }
    }
    update();

    $$('[data-th-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var inp = $('#th-qty');
        if (!inp) return;
        var v = parseInt(inp.value, 10) || 1;
        v += (b.getAttribute('data-th-qty') === 'up' ? 1 : -1);
        inp.value = Math.max(1, v);
      });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (btn && btn.getAttribute('aria-disabled') === 'true') return;
        var qEl = $('#th-qty');
        addToCart(idInput ? idInput.value : null, qEl ? parseInt(qEl.value, 10) || 1 : 1, btn);
      });
    }
  }

  /* ---------- cart ---------- */
  function addToCart(id, qty, btn) {
    if (!id) { toast(S.select_option || 'Διάλεξε παραλλαγή'); return; }
    var sp = btn ? btn.querySelector('span') : null;
    var old = sp ? sp.textContent : '';
    if (sp) sp.textContent = S.adding || 'Προσθήκη…';
    fetch(R.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { return refreshCart(); })
      .then(function () {
        if (sp) sp.textContent = old;
        openDrawer();
      })
      .catch(function () {
        if (sp) sp.textContent = old;
        toast(S.error || 'Κάτι πήγε στραβά.');
      });
  }

  function openDrawer() {
    var d = $('#th-drawer');
    if (!d) { window.location.href = R.cart_url; return; }
    d.classList.add('is-open');
    scrim(true);
  }

  function refreshCart() {
    return fetch(R.cart_url + '?section_id=cart-drawer', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#th-drawer');
        var cur = $('#th-drawer');
        if (fresh && cur) {
          var wasOpen = cur.classList.contains('is-open');
          cur.innerHTML = fresh.innerHTML;
          if (wasOpen) cur.classList.add('is-open');
          bindCart(cur);
        }
        return fetch(R.cart_url + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        $$('[data-th-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        return cart;
      });
  }

  function bindCart(root) {
    $$('[data-th-line]', root || document).forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        changeLine(b.getAttribute('data-th-line'), b.getAttribute('data-th-line-qty'));
      });
    });
  }

  function changeLine(line, qty) {
    fetch(R.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(qty, 10) })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        return refreshCart();
      })
      .catch(function () { toast(S.error || 'Κάτι πήγε στραβά.'); });
  }

  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-th-add]') : null;
      if (!b) return;
      e.preventDefault();
      addToCart(b.getAttribute('data-th-add'), 1, b);
    });
  }

  function initCartBtn() {
    $$('[data-th-open-cart]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
    });
  }

  function initNews() {
    if (window.location.search.indexOf('customer_posted=true') > -1) {
      var ok = $('#th-news-ok');
      if (ok) ok.hidden = false;
      var f = $('#th-news-form');
      if (f) f.hidden = true;
    }
  }

  function boot() {
    initHeader();
    initAnn();
    initSkin();
    initReveal();
    initCounters();
    initAcc();
    initGallery();
    initVariants();
    initQuickAdd();
    initCartBtn();
    initNews();
    bindCart(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* --- Shopify theme editor: τα sections φορτώνουν δυναμικά --- */
  document.addEventListener('shopify:section:load', function (e) {
    reveal(e.target);
    initAcc();
    initGallery();
    initVariants();
    initCartBtn();
    initSkin();
    initCounters();
    initAnn();
  });
  document.addEventListener('shopify:section:select', function (e) { reveal(e.target); });
  document.addEventListener('shopify:block:select', function (e) { reveal(e.target); });

  /* --- δίχτυ ασφαλείας: τίποτα δεν μένει αόρατο --- */
  function reveal(root) {
    $$('.th-rv', root || document).forEach(function (el) { el.classList.add('is-in'); });
  }
  window.addEventListener('load', function () {
    setTimeout(function () {
      $$('.th-rv:not(.is-in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 1.4) el.classList.add('is-in');
      });
    }, 400);
    setTimeout(reveal, 3000);
  });

  window.thRefreshCart = refreshCart;
})();
